export default __webpack_public_path__ + "static/media/Birthday-Cake.4f93a1e5.jpg";